import type { GridProps } from "@mui/material/Grid";
import { AlignType } from "./Row";

export function gridAlignmentConverter(
  align: AlignType
): GridProps["justifyContent"] {
  switch (align) {
    case "left":
      return "flex-start";
    case "right":
      return "flex-end";
    case "center":
      return "center";
    default:
      return "flex-start";
  }
}

export function itemAlignmentConverter(
  align: AlignType
): GridProps["alignItems"] {
  switch (align) {
    case "left":
      return "flex-start";
    case "right":
      return "flex-end";
    case "center":
      return "center";
    default:
      return "flex-start";
  }
}
